import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseLocalRepository as BaseLocalRepository } from '@data/base/base-local.repository';
import { Observable } from 'rxjs';
import { ApiResources } from '@constants/api-resources';
import { ParametrosEntity } from '@domain/dto/parametros/parametros-get.dto';

@Injectable()
export class ParametrosRepository extends BaseLocalRepository {
  constructor(httpCliente: HttpClient) {
    super(httpCliente, ApiResources.PARAMETROS);
  }
  get(router?: string): Observable<ParametrosEntity> {
    const param: string = `Router=${router}`;
    const params = new HttpParams().set('search', param);
    return this.getRequest<ParametrosEntity[]>(params);
  }
}
